export enum AUTH_TYPE {
  LOGIN = 'login',
  SIGNUP = 'signup',
  SIGNUP_PASSWORD = 'signup_password',
  STUDENT_LOGIN = 'student_login',
  CONFIRM_LOGIN = 'confirm_login',
  FORGOT_PASSWORD = 'forgot_password',
  INACTIVE_PASSWORD_RESET = 'inactive_password_reset',
  TWO_FACTOR_VERIFICATION = 'two_factor_verification',
  SAVED_ACCOUNTS = 'saved_accounts',
  SAVED_ACCOUNT_PASSWORD = 'saved_account_password',
}

/** Values of the `authView` URL param, mirroring PHP `EmbeddedEditorAuthView`. */
export enum AuthViewParam {
  SIGNUP = 'signup',
}
